<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.Charge')"
    width="1200px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content warehouse-dialog"
  >
    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
      <el-button @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
    </div>
    <div class="tabs-container">
      <tab-charges
        ref="tabCharge"
        style="min-height: 600px;padding:0;min-width:1180px"
        :charge-source="chargeSource"
        :context="chargeDialog.context"
        :action="chargeDialog.action"
      />
    </div>
  </el-dialog>
</template>

<script>
import TabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { saveSeaBookingSpace } from '@/api/SeaImport/seaImportJob'
import { deepCopy } from '@/utils/commonUtil'
import { getLoading } from '@/utils/utilBaseElement'
import { saveAirImport } from '@/api/AirImport/aiBooking'
import { AirImportJob } from '@/class/model/booking/AirImportJob'

export default {
  name: 'WarehouseChargeDialog',
  components: { TabCharges },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    job: {
      type: Object,
      default: () => {}
    },
    lob: {
      type: String,
      default: () => {}
    }
  },
  data() {
    return {
      chargeDialog: {
        context: {
          modifiedData: {}
        },
        action: 'edit'
      },
      fullscreenLoading: null,
      chargeSource: ChargeUtils.CHARGE_SOURCE_WAREHOUSE.code
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
    innerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.init()
        })
      }
    }
  },
  methods: {
    async init() {
      let jobModel
      if (this.lob === 'SI') {
        jobModel = new SeaImportJob(this.job)
      } else {
        jobModel = new AirImportJob(this.job)
      }
      delete jobModel.charges
      await jobModel.loadJobRelated2({
        job: true, // 脏数据，需要重新载入
        charges: true
      })
      this.$refs['tabCharge'].onShow(deepCopy(this.job, null), true)
    },
    onSubmit() {
      this.fullscreenLoading = getLoading()
      this.getCharges().then(charges => {
        let saveHandler
        if (this.lob === 'SI') {
          saveHandler = saveSeaBookingSpace(charges)
        } else {
          saveHandler = saveAirImport(charges)
        }
        saveHandler.then(res => {
          this.fullscreenLoading.close()
          this.$emit('close')
          this.$message.success(this.$t('Message.SaveSuccessfully'))
        }).catch((error) => {
          this.fullscreenLoading.close()
          this.$message.warning(error['message'])
        })
      }).catch((error) => {
        this.fullscreenLoading.close()
        this.$message.warning(error['message'])
      })
    },
    async getCharges() {
      let tabData
      const getSubmitData = this.$refs['tabCharge'].getSubmitData
      if (getSubmitData && typeof getSubmitData === 'function') {
        /* 获取各页签需要保存的数据 */
        const result = this.$refs['tabCharge'].getSubmitData()
        if (result instanceof Promise) {
          tabData = await result
        } else {
          tabData = result
        }
      }
      return tabData
    },
    onCancel() {
      this.$confirm(this.$t('Message.confirmQuit'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.$emit('close')
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>

</style>
